export enum FormSizeTypes {
  small = 'small',
  medium = 'medium',
}
